import { Kind } from '../../../types/session';
import { toBackendDate } from '../../../utils/dayjs';

export const sessionBase = { description: '', kind: Kind.Presencial, date: toBackendDate(), spots: 0, color: '', branch: '', subject: '', teacher: '' };
export const kindOptions = [{ label: 'Presencial', value: 0 }, { label: 'Online', value: 1 }];
